let BasicColors: any
;(function (BasicColors) {
  BasicColors.maroon = "#800000"
  BasicColors.red = "#FF0000"
  BasicColors.orange = "#FFA500"
  BasicColors.yellow = "#FFFF00"
  BasicColors.olive = "#808000"
  BasicColors.green = "#008000"
  BasicColors.purple = "#800080"
  BasicColors.fuchsia = "#FF00FF"
  BasicColors.lime = "#00FF00"
  BasicColors.teal = "#008080"
  BasicColors.aqua = "#00FFFF"
  BasicColors.blue = "#0000FF"
  BasicColors.navy = "#000080"
  BasicColors.black = "#000000"
  BasicColors.gray = "#808080"
  BasicColors.silver = "#C0C0C0"
  BasicColors.white = "#FFFFFF"
})(BasicColors || (BasicColors = {}))
export const calculateRgba = (color: any, opacity: any) => {
  if (Object.keys(BasicColors).indexOf(color) !== -1) {
    color = BasicColors[color]
  }
  if (color[0] === "#") {
    color = color.slice(1)
  }
  if (color.length === 3) {
    let res = ""
    color.split("").forEach((c: any) => {
      res += c
      res += c
    })
    color = res
  }
  const rgbValues = (color.match(/.{2}/g) || [])
    .map((hex: any) => parseInt(hex, 16))
    .join(", ")
  return `rgba(${rgbValues}, ${opacity})`
}
